// Admin auth API surface.
//
// Backend status (M1 W4): `/admin/v1/auth/login` and `/admin/v1/me` are
// referenced by the architecture but not yet wired in cmd/admin/main.go.
// We code against the spec'd shape so this just works when the backend
// lands the routes — in dev the placeholder middleware passes through
// without a token anyway, so the SPA still functions end-to-end.
//
// On a real deployment the response contains a JWT with scope=admin +
// roles array. We expose a logout helper even though it's a no-op on the
// server side (token clearing is purely client-side until refresh tokens
// land).

import { get, post } from './client';
import type { AdminProfile } from '@/stores/auth';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  expires_at?: string;
  admin: AdminProfile;
}

export function login(req: LoginRequest): Promise<LoginResponse> {
  return post<LoginResponse>('/admin/v1/auth/login', req);
}

export function me(): Promise<AdminProfile> {
  // GET /admin/v1/me — verify token + return current admin profile.
  return get<AdminProfile>('/admin/v1/me');
}

export async function logout(): Promise<void> {
  // Best-effort — backend may or may not have a logout endpoint yet.
  try {
    await post('/admin/v1/auth/logout');
  } catch {
    // ignore — the actual logout is the client-side store clear.
  }
}
